let submit_form = (form, event, additionalData, errorHandler) => {
    if (event && event.preventDefault) {
        event.preventDefault();
    }

    return new Promise((resolve) => { // <-- Wrap in Promise
        let formId = form.id;
        let $form = $(form);
        let data = new FormData(form);

        additionalData = additionalData || {};

        let keys = Object.keys(additionalData);

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            data.append(key, additionalData[key]);
        }

        let $submitButton = $form.find('button[type="submit"]');
        if ($submitButton.length === 0) {
            let selector = 'button[data-form-id="' + formId + '"]';
            $submitButton = $(selector);
        }
        if ($submitButton.length === 0) {
            let selector = 'button[form="' + formId + '"]';
            $submitButton = $(selector);
        }
        if ($submitButton.length === 0) {
            $submitButton = null
        }

        let buttonHtml = window.Smart.utils.disable_button($submitButton);

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: data,
            contentType: false,
            processData: false,
            complete: async function (jqXHR) {
                let response = await window.Smart.utils.ajax_complete_handler(jqXHR, $form);

                if (jqXHR.status > 399) {
                    if (errorHandler) {
                        errorHandler(jqXHR, response);
                        // here we can reject({ jqXHR, response }) if needed but I don't think it's necessary,
                        // since we will probably check response content anyway
                    }
                }

                setTimeout(function () {
                    window.Smart.utils.enable_button($submitButton, buttonHtml);
                    resolve({ jqXHR, response }); // <-- Resolve after enabling
                }, 500)
            }
        });
    });
};

export default submit_form;
